import React from 'react'
import { navigate } from 'gatsby-link'
import { globalHistory } from '@reach/router'
import { graphql , useStaticQuery} from "gatsby"
// import scrollTo from 'gatsby-plugin-smoothscroll';
// import { animateScroll as scroll } from 'react-scroll'
import { SmoothScroll } from '@hooks/useSmoothScroll'
import { useStores } from '@hooks/useStores'

import { useTransition } from "@hooks/useTransitionStatus"

export const Link = ({
	children,
	onClick = ()=>{},
	to = null,
	scrollTarget = null,
	scrollOffset = { pc: 0, sp: 0},
	delay = 0,
	target,
	disableMode = false,
	...props}) => {
	// const q = useStaticQuery(
	// 	graphql`
	// 		query {
	// 			site {
	// 				siteMetadata {
	// 					path_prefix
	// 				}
	// 			}
	// 		}
	// 	`
	// )
	const isProd = Number(process.env.GATSBY_PROD)
	// const { path_prefix } = q.site.siteMetadata
	// const pathPrefix = isProd ? path_prefix : ''

	const transition = useTransition({isStayEnd: true})
	const { appStore } = useStores()
	let { className, key } = props

	const handleClick = (e) => {

		e.stopPropagation()
		e.preventDefault()

		let pathname = globalHistory.location ? globalHistory.location.pathname : null

		if( onClick ) {
			onClick(e)
		}
		//修正必要

		if(  pathname === `${to}` ){
			//遷移させない
			if( scrollTarget ){
				// navigate(`${to}${scrollTarget}`)
				SmoothScroll({target: scrollTarget, offset:scrollOffset})
			}
		} else {
			//遷移する

			if( !scrollTarget ){
				setTimeout(() => {
					navigate(to)
				}, delay)
			} else {
				// navigate(`${to}${scrollTarget}`)
				SmoothScroll({target: scrollTarget, offset:scrollOffset})
			}
		}

	}

	const [isDisable, setIsDisable] = React.useState(false)

	return (
		<React.Fragment>
			{ !to.match(/http/) ?
				<a
					key={key || null}
					href={to}
					className={`${className ? className : ``}`}
					onClick={e => handleClick(e)}
					// style={{opacity: isDisable ? "0.3" : "1.0"}}
				>
					{children}
				</a>
				:
				<a className={`${className ? className : ``}`}
					href={to}
					onClick={e => onClick(e)}
					target={target}
					rel="noopener noreferrer"
				>
					{children}
				</a>
			}
		</React.Fragment>
	)
}